'use client';

import {FC} from 'react';
import Image from 'next/image';
import {StatisticsSec} from '@/app/[locale]/[[...slug]]/types';
import {
  StyledStatisticsSectionContainer,
  StyledStatisticsSectionContent,
  StyledStatisticsGrid,
  StyledStatisticsItem,
  StyledStatisticsItemRow,
  StyledStatisticsHeading,
  StyledStatisticsNumberUnit,
  StyledStatisticsDescription,
} from '@/components/sections/statistics-section/StatisticsSection.styles';
import CountUp from '@/components/sections/statistics-section/CountUp';
import {StyledSectionContainer} from '@/components/sections/shared/Section.styles';
import {Container} from '@mui/material';

type StatisticsSectionProps = {
  section: StatisticsSec;
};

export const StatisticsSection: FC<StatisticsSectionProps> = ({section}) => {
  const heading = section.heading;
  const items = section.statisticalItemsCollection?.items ?? [];

  return (
    <Container>
      <StyledSectionContainer maxWidth='mdlg'>
        <StyledStatisticsSectionContainer {...(section.id && {id: section.id})}>
          <StyledStatisticsSectionContent>
            {heading && (
              <StyledStatisticsHeading variant='h4'>
                {heading}
              </StyledStatisticsHeading>
            )}

            {items.length > 0 && (
              <StyledStatisticsGrid>
                {items.map((item, i) => {
                  if (!item) return null;
                  return (
                    <StyledStatisticsItem key={i}>
                      <StyledStatisticsItemRow>
                        <div>
                          {item.amount != null && <CountUp end={item.amount} />}{item.amount != null && ' '}{item.numberUnit && (
                            <StyledStatisticsNumberUnit component='span' variant='h3'>
                              {item.numberUnit}
                            </StyledStatisticsNumberUnit>
                          )}
                        </div>
                        {item.icon?.url && (
                          <Image src={item.icon.url} alt='' width={48} height={48} />
                        )}
                      </StyledStatisticsItemRow>
                      {item.description && (
                        <StyledStatisticsDescription variant='body1'>
                          {item.description}
                        </StyledStatisticsDescription>
                      )}
                    </StyledStatisticsItem>
                  );
                })}
              </StyledStatisticsGrid>
            )}
          </StyledStatisticsSectionContent>
        </StyledStatisticsSectionContainer>
      </StyledSectionContainer>
    </Container>
  );
};
